import React from 'react';
import './Build.css';
import * as loggingUtils from "./utils/loggingUtils";
import * as encryptUtils from "./encryptDecryptUtils";
import { useNavigate, useLocation } from "react-router-dom";

function Build(props) {
  const navigate = useNavigate();
  const location = useLocation();

  function handleClickLiquid() {
    navigate("/liquidupload")
  }

  return (
    <div className="md:flex flex-none w-full min-h-screen">
      <iframe className="h-96 md:min-h-screen w-full md:w-1/2"src='https://my.spline.design/tunesnftgoldcopycopycopycopycopy-cab7cbe5a145d33d4d3aec4aa2239540/'></iframe>
      <div className="w-full md:w-1/2 flex flex-col justify-around">
        <div className="font-semibold md:h-4/6 flex flex-col justify-around ml-20">
        <div className="text-2xl font-semibold text-gray-600 dark:text-white sm:mt-0 mt-8 mb-8">
          Which would you like to try?
        </div>
          <div>
          <div className="liquidButton" onClick={
            ()=> {
              loggingUtils.logEvent(
                props.account != null
                  ? props.account.address
                  : encryptUtils.getWalletUnconnectedUserId(),
                "build",
                "build_visit_liquid_typeform",
                "info",
                "https://the402.xyz",
                {}
              );
              window.open("https://the402.typeform.com/to/TccoteXQ", "_blank")
            }
          }>
            Liquid Protocol
          </div>
          <div className="mt-2 text-gray-400 font-normal text-sm">
            NFTs that can be bought and sold instantly
          </div>
          <div className="sm:mb-0 mb-4 text-gray-400 font-normal text-sm">
            Create your own liquidity period and pricing
          </div>
          </div>
          <div>
          <div className="sm:mt-0 mt-4 bg-purple-600 dark:bg-purple-600 h-16 w-72 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-white cursor-pointer"
            onClick={
              () => {
                loggingUtils.logEvent(
                  props.account != null
                    ? props.account.address
                    : encryptUtils.getWalletUnconnectedUserId(),
                  "build",
                  "build_visit_fuse_typeform",
                  "info",
                  "https://the402.xyz",
                  {}
                );
                window.open(window.location.origin + "/nounsupload", "_self")

              }
            }
          >
            Creator Nouns ⌐◨-◨
          </div>
          <div className="mt-2 text-gray-400 font-normal text-sm">
            Raise funding in a recurring way
          </div>
          <div className="text-gray-400 font-normal text-sm">
            Instead of relying on one-off NFT drops
          </div>
          </div>
          <div>
          <div className="the402Button" onClick={
            () => {
              loggingUtils.logEvent(
                props.account != null
                  ? props.account.address
                  : encryptUtils.getWalletUnconnectedUserId(),
                "build",
                "build_visit_the402_typeform",
                "info",
                "https://the402.xyz",
                {}
              );
              window.open("https://the402.typeform.com/to/HtjiPcno", "_blank")
            }
          }>
            402 Protocol
          </div>
          <div className="mt-2 text-gray-400 font-normal text-sm">
            Encrypted media
          </div>
          <div className="text-gray-400 font-normal text-sm">
            Get paid instantly as people stream your content
          </div>
          <div className="sm:mb-0 mb-4 text-gray-400 font-normal text-sm">
            Share upside with collectors
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Build;
